/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  CDLACNumber: {
    id: 'App.ViewProperty.PropertyStateConfig.CDLACNumber',
    defaultMessage: 'CDLAC Number / Allocation',
  },
  CDLACNumberToolTip: {
    id: 'App.ViewProperty.PropertyStateConfig.CDLACNumberToolTip',
    defaultMessage:
      'Used for California TIC reporting. If no CDLAC Number is provided, the Project Number will be used instead.',
  },
  invalidCDLACNumber: {
    id: 'App.ViewProperty.PropertyStateConfig.invalidCDLACNumber',
    defaultMessage:
      'CDLAC Number / Allocation must only contain numbers with dashes. (i.e. 1234-567, 12345)',
  },
});

export default messages;
